// extracted by mini-css-extract-plugin
export var legendIndicator = "_ci-1";
export var legendRight = "_ci-0";